<template>
	<v-container fluid class="ma-0 pa-0">
		<v-col class="ma-0 pa-0 pl-3 pr-3" cols="12" id="head_title">
			<v-row class="ma-0 pa-0" align="center" id="header_height">
				<v-col class="ma-0 pa-0" cols="auto">
					<v-btn id="back_clean_btn" width="auto" height="50px"
						class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
						@click="routerBack">
						{{'トップ'}}
					</v-btn>
				</v-col>
				<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
					src="@/assets/images/history_arrow.png"></v-img>
				<v-col class="ma-0 pa-0" cols="auto">
					<v-btn id="back_clean_btn" width="auto" height="50px"
						class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
						@click="routerBack">
						{{'検索結果'}}
					</v-btn>
				</v-col>
				<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
					src="@/assets/images/history_arrow.png"></v-img>
				<v-col class="ma-0 pa-0" cols="auto">
					<v-btn id="back_clean_btn" width="auto" height="50px"
						class="ma-0 pa-0" elevation="0" style="color:#08B0FF;font-size:1rem;"
						@click="routerBack">
						{{'吉祥寺北口店'}}
					</v-btn>
				</v-col>
				<v-img max-height="100%" max-width="1.5rem" class="ma-0 pa-0 mr-3"
					src="@/assets/images/history_arrow.png"></v-img>
				<v-col class="ma-0 pa-0" cols="auto">
					{{'マップの編第'}}
				</v-col>
				<v-spacer />
				<v-row class="ma-0 pa-0" align="center" justify="end">
					<v-col class="ma-0 pa-0 pl-1" cols="auto"
						style="color: #979FB1;font-size:0.8rem;">
						{{'接続デバイス 8台'}}
					</v-col>
					<v-btn width="auto" height="50px" class="ma-0 pa-0 pl-1 pr-1 ml-5" 
						id="back_clean_btn" elevation="0" @click="shareUserDialogVisible = true">
						<v-row class="ma-0 pa-0" align="end">
							<v-img max-height="1.5rem" max-width="1.25rem" class="ma-0 pa-0 mr-1"
								src="@/assets/images/icon_user.png"></v-img>
							<v-col class="ma-0 pa-0 pl-1 pb-1" cols="auto"
								style="color: #979FB1;font-size:0.8rem;">
								{{'5人共有中'}}
							</v-col>
							<v-img max-height="1rem" max-width="1rem" class="ma-0 pa-0"
								src="@/assets/images/corner_bottom_arrow.png"></v-img>
						</v-row>
					</v-btn>
				</v-row>
			</v-row>
		</v-col>

    <v-row class="ma-0 pa-0">
      <v-col id="store_detail_nav" class="ma-0 pa-0" cols="2">
				<v-col class="ma-0 pa-3" cols="auto" align="center">
					<v-menu offset-y>
						<template v-slot:activator="{ on, attrs }">
							<v-btn id="blue_btn" width="10rem" height="2rem"
								class="ma-0 pa-0" elevation="0" v-bind="attrs" v-on="on">
								<v-row class="ma-0 pa-0" align="end" justify="center">
									<v-col class="ma-0 pa-0 pl-1 pb-1" cols="auto">
										{{'マップを作成する'}}
									</v-col>
									<v-img max-height="0.7rem" max-width="0.5rem" class="ma-0 pa-0 mb-1 ml-1"
										src="@/assets/images/corner_bottom_arrow_white.png"></v-img>
								</v-row>
							</v-btn>
						</template>
						<v-list class="ma-0 pa-0" dense>
							<v-list-item>
								<v-list-item-title align="left">{{ '図面を取り込む' }}</v-list-item-title>
							</v-list-item>
							<v-list-item>
								<v-list-item-title align="left">{{ '新規図面を作成する' }}</v-list-item-title>
							</v-list-item>
							<v-list-item>
								<v-list-item-title align="left">{{ '他の店舗マップを取り込む' }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
					<v-col class="ma-0 pa-5" cols="auto" align="center"
						v-for="item, index in storeMapBluePrintList" :key="index">
						<v-col id="blueprint_box" class="ma-0 pa-3" cols="auto"
							:class="{'click_blueprint_box': item.name == selectBluePrint}"
							@click="selectSetBluePrint(item)">
							<v-img max-height="8rem" max-width="8rem" class="ma-0 pa-0"
								:src="item.img" contain
							></v-img>
							<v-col id="blueprint_btn" class="ma-0 pa-0" cols="auto">
								<v-menu offset-y>
									<template v-slot:activator="{ on, attrs }">
										<v-btn id="back_clean_btn" class="ma-0 pa-0"
											width="auto" height="1.5rem" v-bind="attrs" v-on="on">
											<v-img height="1.5rem" width="1.5rem" class="ma-0 pa-0"
												src="@/assets/images/more_black.png"></v-img>
										</v-btn>
									</template>
									<v-list class="ma-0 pa-0" dense>
										<v-list-item>
											<v-list-item-title align="left">{{ 'コビーする' }}</v-list-item-title>
										</v-list-item>
										<v-list-item>
											<v-list-item-title align="left">{{ '第線する' }}</v-list-item-title>
										</v-list-item>
									</v-list>
								</v-menu>
							</v-col>
						</v-col>
					</v-col>
				</v-col>
			</v-col>
      <v-col class="ma-0 pa-0" cols="10">
				<v-col id="blueprint_header" class="ma-0 pa-3" cols="12">
					<v-row class="ma-0 pa-0" align="center" justify="space-between">
						<v-col class="ma-0 pa-0" cols="auto">
							<v-row class="ma-0 pa-0 pl-5" align="center">
								<v-col class="ma-0 pa-0" cols="auto">{{'フロア名'}}:</v-col>
								<v-col class="ma-0 pa-0 ml-3" cols="auto">{{'1F'}}</v-col>
							</v-row>
						</v-col>
						<v-col class="ma-0 pa-0" cols="auto">
							<v-btn id="grey_btn" class="ma-0 pa-0"
								width="10rem" height="2rem" style="font-size:0.8rem;">
								{{ 'このマップを編集する' }}
							</v-btn>
						</v-col>
					</v-row>
				</v-col>
        <v-col class="pa-0" id="main_content_maxwidthset" cols="12">
					
					<v-col class="ma-0 pa-6" cols="12" align="center">
						<v-img height="80vh" width="50rem" class="ma-0 pa-0"
							src="@/assets/images/store_map_test1.png"></v-img>
					</v-col>
				</v-col>
			</v-col>
		</v-row>
		<!-- <ShareUserDialog :dialogVisible="shareUserDialogVisible"
      @visible="shareUserDialogVisibleFunc" /> -->
	</v-container>
</template>

<script>
import mixin from '@/mixin';
import ShareUserDialog from '@/components/dialogs/ShareUserDialog.vue';
export default {
	components: {
		ShareUserDialog
	},
	mixins: [mixin.common],
	data: () => ({
		shareUserDialogVisible: false,
		storeMapBluePrintList: [
			{ name: '1F', img: require(`@/assets/images/test_map_blueprint.png`) },
			{ name: '2F', img: require(`@/assets/images/test_map_blueprint.png`) },
			{ name: '3F', img: require(`@/assets/images/test_map_blueprint.png`) },
			{ name: '4F', img: require(`@/assets/images/test_map_blueprint.png`) },
			{ name: '5F', img: require(`@/assets/images/test_map_blueprint.png`) },
		],
		selectBluePrint: '1F',
	}),
	methods: {
		shareUserDialogVisibleFunc(visible) {
      this.shareUserDialogVisible = visible;
    },
		selectSetBluePrint(item) {
			this.selectBluePrint = item.name;
		}
	}
}
</script>

<style lang="scss" scoped>
.v-list {
  background: #171921;
	border: 1px solid #4A4A4A;
}
::v-deep {
  .v-list-item__title{
    color: white;
  }
}
#store_detail_nav{
  background: #171921;
	height: calc(100vh - 50px);
	overflow-y: auto;
	&::-webkit-scrollbar {
		width: 3px;
	}
	&::-webkit-scrollbar-thumb {
		background-color: white;
	}
	&::-webkit-scrollbar-track {
		background-color: #4A4A4A;
	}
}
#blueprint_box {
	position: relative;
	border: 1px solid #484848;
	cursor: pointer;
}
.click_blueprint_box {
	border: 2px solid #008DD0 !important;
}
#blueprint_btn {
	position: absolute;
	right: 5px;
	top: 5px;
	z-index: 3;
}
#blueprint_header {
	border-bottom: 1px solid #484848;
	font-size: 0.9rem;
}
</style>